import { render, staticRenderFns } from "./CertificateForm.vue?vue&type=template&id=2ab73472&scoped=true"
import script from "./CertificateForm.vue?vue&type=script&lang=ts"
export * from "./CertificateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab73472",
  null
  
)

export default component.exports